export const presaleAddress = "0x3cce423604205e53b148A87254038C55756b8838";
export const tokenAddress = "0x584a4Dd38d28fD1EA0E147bA7B70AEd29A37e335";
export const usdtAddress = "0xdAC17F958D2ee523a2206206994597C13D831ec7";
